import { render, staticRenderFns } from "./knowledgeDetail.vue?vue&type=template&id=466820f4&scoped=true"
import script from "./knowledgeDetail.vue?vue&type=script&lang=js"
export * from "./knowledgeDetail.vue?vue&type=script&lang=js"
import style0 from "./knowledgeDetail.vue?vue&type=style&index=0&id=466820f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466820f4",
  null
  
)

export default component.exports